import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ServicesSection } from '../components/ServicesSection';
import { SolutionsSection } from '../components/SolutionsSection';
import { PricingSection } from '../components/PricingSection';
export function HomePage() {
  return <>
      <HeroSection data-id="element-613" />
      <ServicesSection data-id="element-614" />
      <SolutionsSection data-id="element-615" />
      <PricingSection data-id="element-616" />
    </>;
}